import { useTheme } from 'styled-components';
import Column from '../components/box/column';
import SizedBox from '../components/box/sizedBox';
import Center from '../components/center';
import { LXh5 } from '../texts/lxText';

const LXError = () => {
  const theme = useTheme();

  return (
    <Center>
      <Column justifyContent="center" alignItems="center">
        <LXh5>Sorry! Something went wrong</LXh5>
        <SizedBox height={8}></SizedBox>
        <LXh5>Please Refresh page</LXh5>
        <SizedBox height={8}></SizedBox>
        <LXh5>If error again. connect us</LXh5>
        <SizedBox height={8}></SizedBox>
        <LXh5>{`Email : ${theme.texts.slxEmail}`}</LXh5>
      </Column>
    </Center>
  );
};

export default LXError;
